import React from "react";

/**
 * Vertical rhythm + container wrapper shared by every marketing section.
 * Spacing/width values are fixed to design-system/landing.md §3, not meant
 * to be overridden per-call — sections should look like one system.
 */
export default function Section({ id, variant = "default", className = "", children }) {
  return (
    <section
      id={id}
      className={`py-24 md:py-32 ${variant === "elevated" ? "bg-rf-bg-elevated" : ""} ${className}`}
    >
      <div className="mx-auto max-w-6xl px-6 md:px-8">{children}</div>
    </section>
  );
}
